export default __webpack_public_path__ + "static/media/ntg.cab841bd.svg";